import { render, staticRenderFns } from "./modalFiltroAfiliados.vue?vue&type=template&id=24a3d574"
import script from "./modalFiltroAfiliados.vue?vue&type=script&lang=js"
export * from "./modalFiltroAfiliados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports